import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { loadLanguageTranslations } from './local/index';
import { LANGUAGE_STORAGE_KEY, SUPPORTED_LANGUAGES, normalizeLanguage } from './config';

function detectLanguage(): string {
  const stored = localStorage.getItem(LANGUAGE_STORAGE_KEY);
  if (stored) return normalizeLanguage(stored);
  return normalizeLanguage(navigator.language);
}

async function initI18n() {
  const lang = detectLanguage();
  const translations = await loadLanguageTranslations(lang);

  await i18n.use(initReactI18next).init({
    lng: lang,
    fallbackLng: 'sk',
    supportedLngs: [...SUPPORTED_LANGUAGES],
    load: 'languageOnly',
    debug: false,
    resources: {
      [lang]: { translation: translations },
    },
    interpolation: {
      escapeValue: false,
    },
  });

  i18n.on('languageChanged', async (newLang) => {
    const normalized = normalizeLanguage(newLang);
    if (!i18n.hasResourceBundle(normalized, 'translation')) {
      const t = await loadLanguageTranslations(normalized);
      i18n.addResourceBundle(normalized, 'translation', t);
    }
    localStorage.setItem(LANGUAGE_STORAGE_KEY, normalized);
  });
}

export const i18nReady = initI18n();

export default i18n;
